import React, { useEffect, useState } from "react";
import classes from "./CorporateCard.module.css";
import CommonCard from "../CommonCard";
import NameDetailTemplate from "../NameDetailTemplate";
import LabelValue from "../LabelValue";
import { LocationIcon } from "../../constant";
import clsx from "clsx";
import { CheveronDown, Pencil, Trash } from "../../constant";
import EditAndDeleteAction from "../EditAndDeleteAction";
import Popover from "../Popovers";
import AreYouSureModal from "../../modals/AreYouSureModal";
import AddOrEditCouponsModal from "../../modals/Coupons/AddOrEditCouponsModal";
import { formatNumberWithCommas } from "../../helpers";
import { toast } from "react-toastify";

const CircleIndicator = ({ value }) => {
  return (
    <span
      className={clsx(classes.circle, {
        [classes.inactive]: !value,
      })}
    ></span>
  );
};

const CorporateCard = ({ data, menu, updateOrDeleteCoupon, index }) => {
  const [couponsMenu, setCouponsMenu] = useState([]);
  const [showAddOrEditCouponModal, setShowAddOrEditCouponModal] =
    useState(false);
  const [showAreYouSureModal, setShowAreYouSureModal] = useState(false);
  const [selectedCoupon, setSelectedCoupon] = useState(null);
  const [activeCoupons, setActiveCoupons] = useState([]);

  // Filter active coupons whenever data changes
  useEffect(() => {
    if (data?.corporateCoupons?.length > 0) {
      const filtered = data.corporateCoupons.filter(
        (coupon) => coupon.active === true
      );
      setActiveCoupons(filtered);
    } else {
      setActiveCoupons([]);
    }
  }, [data?.corporateCoupons]);

  // Select the first active coupon as default
  useEffect(() => {
    if (activeCoupons.length > 0) {
      setSelectedCoupon(activeCoupons[0]);
    } else {
      setSelectedCoupon(null);
    }
  }, [activeCoupons]);

  // Set up the dropdown menu with active coupons except the selected one
  useEffect(() => {
    if (activeCoupons.length > 1 && selectedCoupon) {
      // Filter out the selected coupon from the menu items
      const menuItems = activeCoupons
        .filter((coupon) => coupon.couponId !== selectedCoupon.couponId)
        .map((coupon) => ({
          label: coupon?.couponCode,
          command: () => setSelectedCoupon(coupon),
          icon: (
            <EditAndDeleteAction
              onDelete={() => {
                setSelectedCoupon(coupon);
                setShowAreYouSureModal(true);
              }}
              onEdit={() => {
                setSelectedCoupon(coupon);
                setShowAddOrEditCouponModal(true);
              }}
            />
          ),
          iconPos: "right",
        }));

      setCouponsMenu(menuItems);
    } else {
      setCouponsMenu([]);
    }
  }, [activeCoupons, selectedCoupon]);

  return (
    <>
      <CommonCard className={classes.wrapper}>
        <ol>
          <li>
            <NameDetailTemplate
              heading={data?.corporateName}
              description={data?.corporateType}
              logo={data?.corporateLogo}
              menuList={menu}
            />
          </li>
          {activeCoupons.length > 0 && selectedCoupon && (
            <li>
              <div className={classes.tagsGrid}>
                <CommonCard className={classes.dataPill}>
                  <LabelValue
                    label={<CircleIndicator value={data?.active} />}
                    value={data?.active ? "Active" : "Inactive"}
                  />
                </CommonCard>
                <CommonCard className={classes.dataPill}>
                  <LabelValue
                    label={"Coupon Code:"}
                    value={selectedCoupon?.couponCode}
                    valueClass={classes.primaryColor}
                    children={
                      activeCoupons?.filter((item) => item?.active).length >
                      1 ? (
                        <Popover
                          children={<CheveronDown className={classes.icon} />}
                          items={couponsMenu}
                        />
                      ) : null
                    }
                  />
                </CommonCard>
                <CommonCard className={classes.dataPill}>
                  <LabelValue
                    label={<LocationIcon />}
                    value={data?.corporateCity}
                  />
                </CommonCard>
                <CommonCard className={classes.dataPill}>
                  <LabelValue
                    labelClass={classes.priceLabel}
                    label={selectedCoupon?.couponDiscountAmount ? "Rs." : "%."}
                    value={`${formatNumberWithCommas(
                      selectedCoupon?.couponDiscountAmount
                        ? selectedCoupon?.couponDiscountAmount
                        : selectedCoupon?.couponDiscountPercentage
                    )} OFF`}
                  />
                </CommonCard>
              </div>
            </li>
          )}
        </ol>
      </CommonCard>

      {showAddOrEditCouponModal && selectedCoupon && (
        <AddOrEditCouponsModal
          data={selectedCoupon}
          setShow={setShowAddOrEditCouponModal}
          show={showAddOrEditCouponModal}
          onClose={() => setShowAddOrEditCouponModal(false)}
          coupon={selectedCoupon}
          onSubmit={(params) => {
            (async () => {
              try {
                await updateOrDeleteCoupon(params, index);
                setShowAddOrEditCouponModal(false);
              } catch (error) {
                toast.error(error?.response?.data?.headers?.message);
                console.log("error", error);
              }
            })();
          }}
        />
      )}

      {showAreYouSureModal && selectedCoupon && (
        <AreYouSureModal
          title="Coupon"
          setShow={setShowAreYouSureModal}
          show={showAreYouSureModal}
          onClose={() => setShowAreYouSureModal(false)}
          onConfirm={() => {
            if (
              updateOrDeleteCoupon &&
              typeof updateOrDeleteCoupon === "function"
            ) {
              updateOrDeleteCoupon(
                {
                  couponId: selectedCoupon?.couponId,
                  couponStartDate: null,
                  couponEndDate: null,
                  delete: true,
                },
                index
              );
            }
            setShowAreYouSureModal(false);
          }}
        />
      )}
    </>
  );
};

export default CorporateCard;
